import React from 'react';
import { useInvitationContext } from '../contexts/InvitationContext';

const PersistentInvitationBanner: React.FC = () => {
  const { pendingInvitation, acceptInvitation, rejectInvitation } = useInvitationContext();

  if (!pendingInvitation) {
    return null;
  }

  const gameModeText = pendingInvitation.gameMode === 'alternating' ? 'Gemeinsames Frördle' : '1 vs 1 Frördle';

  const handleAccept = () => {
    acceptInvitation();
    // Navigation will happen via socket event
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-blue-100 border-b border-blue-400 text-blue-700 px-4 py-3 shadow-lg">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <p className="font-semibold text-sm sm:text-base">
            Einladung von {pendingInvitation.fromUsername}
          </p>
          <p className="text-xs sm:text-sm text-blue-600">
            Modus: {gameModeText}
          </p>
        </div>
        <div className="flex gap-2 sm:gap-4 w-full sm:w-auto">
          <button
            onClick={handleAccept}
            className="flex-1 sm:flex-none bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 sm:px-6 rounded-lg transition duration-200 text-sm sm:text-base min-h-[44px]"
          >
            Annehmen
          </button>
          <button
            onClick={rejectInvitation}
            className="flex-1 sm:flex-none bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 sm:px-6 rounded-lg transition duration-200 text-sm sm:text-base min-h-[44px]"
          >
            Ablehnen
          </button>
        </div>
      </div>
    </div>
  );
};

export default PersistentInvitationBanner;

